// Values must match the API's JSON casing (JsonStringEnumConverter with CamelCase naming policy).
export enum SnapshotBatchStatus {
    Queued = 'queued',
    Processing = 'processing',
    Completed = 'completed',
    CompletedWithErrors = 'completedWithErrors',
    Failed = 'failed',
}
